import { defineEvent } from '../types/event';
export var PRODUCT_TILE_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Click_on_Product_Tile'
        }
    ]
});
